import { useEffect, useState } from 'react';

import useControllerGantBond from '../hooks/useControllerGantBond';
import useControllerGantBorderDate from '../hooks/useControllerGantBorderDate';
import useSaveToServer from '../hooks/useSaveToServer';

const GantLeftHeaderHookController = () => {
    useControllerGantBorderDate();
    useControllerGantBond();
    useSaveToServer();

    const [_, setIsInit] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsInit(true);
        }, 100);
    }, []);

    return null;
};

export default GantLeftHeaderHookController;
